var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showSocial || _vm.showIncidents)?_c('div',{class:{
    'hyp-source-container-2': !_vm.showIncidents,
    'hyp-source-container-3': _vm.showIncidents,
  }},[_c('div',{staticClass:"pull-left text-center hyp-source-btn hyp-source-btn-left",class:{
      'hyp-source-btn-selected': _vm.selectedType === 'news',
      'hyp-source-btn-2': !_vm.showIncidents || !_vm.showSocial,
      'hyp-source-btn-3': _vm.showIncidents && _vm.showSocial,
      disabled: _vm.hasEssentialsAccess,
    },on:{"click":function($event){return _vm.toggle('news')}}},[_vm._v(" News ")]),(_vm.showSocial)?_c('div',{staticClass:"pull-left text-center hyp-source-btn",class:{
      'hyp-source-btn-selected': _vm.selectedType === 'social',
      'hyp-source-btn-2 hyp-source-btn-right': !_vm.showIncidents || !_vm.showSocial,
      'hyp-source-btn-3 hyp-source-btn-middle': _vm.showIncidents && _vm.showSocial,
      disabled: _vm.hasEssentialsAccess,
    },on:{"click":function($event){return _vm.toggle('social')}}},[_vm._v(" Social ")]):_vm._e(),(_vm.showIncidents)?_c('div',{staticClass:"pull-left text-center hyp-source-btn hyp-source-btn-right",class:{
      'hyp-source-btn-selected': _vm.selectedType === 'incidents',
      'hyp-source-btn-2': !_vm.showIncidents || !_vm.showSocial,
      'hyp-source-btn-3': _vm.showIncidents && _vm.showSocial,
    },on:{"click":function($event){return _vm.toggle('incidents')}}},[_vm._v(" Verified ")]):_vm._e(),_c('div',{staticClass:"clearfix"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }